import device from '../device';
import getUrlInfo from '../getUrlInfo';

function getSupportEmailLinkForReportingError(errorMsg: string, errorStack: string) {
    const subject = 'Alan AI Studio Support';
    const space = '%0D%0A';
    const browserInfo = device.getBrowserInfo();
    const urlInfo = getUrlInfo();
    const { dialog, voice } = window.debugInfo;
    const webVersion = window.debugInfo['web version'];

    let bodyLines = [
        `Hi Alan Team,`,
        `I'd like to report a problem,`,
        ``,
        `<--Add details if it's needed -->`,
        ``,
        ``,
        `-------`,
        `Error Info:`,
        `${errorMsg}`,
    ];

    bodyLines = [...bodyLines, ...errorStack.split('\n')];
    bodyLines.push(`-------`);

    if (urlInfo.projectName) {
        bodyLines.push(`Project: ${urlInfo.projectName}`);
    }
    if (urlInfo.scriptName) {
        bodyLines.push(`Script: ${urlInfo.scriptName}`);
    }

    bodyLines.push(`Browser: ${browserInfo.name}`);
    bodyLines.push(`Browser version: ${browserInfo.version}`);
    bodyLines.push(`Screen size: ${browserInfo.screen}`);
    bodyLines.push(`Platform: ${browserInfo.os} ${browserInfo.osVersion}`);
    bodyLines.push(`UserAgent: ${window.navigator.userAgent}`);
    bodyLines.push(`UI language: ${window.navigator.language}`);
    bodyLines.push(`Alan AI Studio version: ${webVersion}`);

    if (dialog) {
        bodyLines.push(`Dialog version: ${dialog}`);
    }
    if (voice) {
        bodyLines.push(`Voice version: ${voice}`);
    }

    const body = bodyLines.join(space);

    return `mailto:support@alan.app?subject=${subject}&body=${body}`;
}

export default getSupportEmailLinkForReportingError;
